require('es6-promise').polyfill();
import $ from 'jquery';
import 'bootstrap';
import 'slick-carousel';
window.jQuery = $;


var VF = {
    init: function() {
        // this.SlickSliderPhones();
        this.scrollToSection();
        this.mobileMenuToggle();
        this.trackingClickPhones();
        this.trackingClickTabs();
    },
    SlickSliderPhones: function() {
    	$('.phone-items').slick({
		    dots: false,
		  	infinite: true,
		  	speed: 300,
		  	slidesToShow: 3,
		  	prevArrow: "<span class='slick-arrow-left'><img src='https://static.vodafone.ro/esim/assets/images/arrow-left.png'>",
    		nextArrow: "<span class='slick-arrow-right'><img src='https://static.vodafone.ro/esim/assets/images/arrow-right.png'>",
		  	responsive: [
		  		{
		      		breakpoint: 1199,
		      		settings: {
		        		slidesToShow: 2,
		        		slidesToScroll: 1,
		        		arrows: true
		      		}
		    	},
		    	{
		      		breakpoint: 768,
		      		settings: {
		        		slidesToShow: 1,
		        		slidesToScroll: 1,
		        		arrows: true
		      		}
		    	}
		  	]
		});
    },
    scrollToSection: function() {
    	// Top Menu scroll to section
	    $('.main-navigation, .main-navigation--mobile').on('click', 'li a', function(){
	        var element = $(this).data('section');

	        $('html, body').animate({
	            scrollTop: $(element).offset().top - 80
	        }, 1000);
	    });
    },
    mobileMenuToggle: function() {
    	// Hamburger Toggle
	    $('.hamburger').on('click', function() {
	        $(this).parents('.section--navigation').toggleClass('js--active');
	    });
    },
    trackingClickPhones: function() {
    	var phoneName,
			phoneBrand;

    	$('.phone-item_img a').on('click', function(){
    		var t = $(this);

    		phoneName = t.data('name');
    		phoneBrand = t.data('brand');

    		dataLayer.push({
				'event':'microData', // required for every push
				'event_name':'action_click', // vetting_view, checkout_view, product_view
				'click_element_name':phoneName +' - eSIM', //should be product_name
				'ecommerce':{
					'click':{
						products:[
						{
							'name': phoneName,
							'price':'0',
							'id':'sku',
							'brand':phoneBrand,
							'category':'telefoane'
						}
					]}
				}
			});
    	});

    	$('.phone-item_name a').on('click', function(){
    		var t = $(this);

    		phoneName = t.data('name');
    		phoneBrand = t.data('brand');

    		dataLayer.push({
				'event':'microData', // required for every push
				'event_name':'action_click', // vetting_view, checkout_view, product_view
				'click_element_name':phoneName +' - eSIM', //should be product_name
				'ecommerce':{
					'click':{
						products:[
						{
							'name': phoneName,
							'price':'0',
							'id':'sku',
							'brand':phoneBrand,
							'category':'telefoane'
						}
					]}
				}
			});
    	});
    },
    trackingClickTabs: function() {
    	var phoneBrandTabs;

    	$('#myTab .nav-link').on('click', function(){
    		var t = $(this);

    		phoneBrandTabs = t.data('brand');

    		dataLayer.push({
				'event':'microData', // required for every push
				'event_name':'action_click',
				'click_element_name': phoneBrandTabs + ' Tab - eSIM'
			});
    	});
    }
};

VF.init();